<template>
  <div class="amazon_edit" style="width: 90%">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right; margin: 0 0 8px 0; padding-top: 10px">
      <el-button @click="handleSaveForm" size="small" type="primary"
        >保存模板</el-button
      >
    </div>
    <Template @save="handleSaveForm" @submit="handleSubmit" ref="template"></Template>
  </div>
</template>

<script type="text/ecmascript-6">
import Template from './components/template.vue'
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "createTemplate",
  components: { Template, Breadcrumb },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    handleSaveForm(){
      this.$refs['template'].handleSaveForm()
    },
    handleSubmit(){
      this.$router.push('/carry/amazon/template');
    }
  },
 async mounted() {
  },
};
</script>

<style lang="scss" scoped></style>
